export function getWeekOfDate(date: Date): number {
  // Set current date to midnight
  const currentDate = new Date(date);
  currentDate.setUTCHours(0, 0, 0, 0);

  // Get the first day of the year
  const firstDateOfYear = new Date(Date.UTC(currentDate.getFullYear(), 0, 1));

  // Get the last day of the year
  const lastDateOfYear = new Date(Date.UTC(currentDate.getFullYear(), 11, 31));

  // Get first week day of the year (Monday = 0, Sunday = 6)
  let firstWeekDayOfYear = firstDateOfYear.getDay() - 1;
  if (firstWeekDayOfYear === -1) {
    firstWeekDayOfYear = 6;
  }

  // Get last week day of the year (Saturday = 5, Sunday = 6)
  let lastWeekDayOfYear = lastDateOfYear.getDay() - 1;
  if (lastWeekDayOfYear === -1) {
    lastWeekDayOfYear = 6;
  }

  // Get the day of the year 1-365
  const dayOfYear =
    Math.floor(
      currentDate.getTime() / 60 / 60 / 24 / 1000 -
        firstDateOfYear.getTime() / 60 / 60 / 24 / 1000,
    ) + 1;

  // Get the number of days since the first Monday of the first week
  const daysSinceFirstMondayOfFirstWeek =
    firstWeekDayOfYear <= 3
      ? dayOfYear + firstWeekDayOfYear
      : dayOfYear - firstWeekDayOfYear + 1;

  /**
   * Get the current week based of days since the first Monday of the first week of the year
   * If less than zero means its week 53 of last year
   */
  let currentWeek =
    daysSinceFirstMondayOfFirstWeek > 0
      ? Math.ceil(daysSinceFirstMondayOfFirstWeek / 7)
      : 53;

  // Check if the current week is 53 and the last week day of the year is less than 3, if so set to 1
  if (currentWeek === 53 && lastWeekDayOfYear < 3) {
    currentWeek = 1;
  }

  return currentWeek;
}

export function getWeeksOfYear(year: number): number {
  const weekOfLastDateOfYear = getWeekOfDate(new Date(Date.UTC(year, 11, 31)));
  if (weekOfLastDateOfYear === 1) {
    return 52;
  }
  return weekOfLastDateOfYear;
}

export function getMondayOfWeek(year: number, week: number): Date {
  // Get first week of year (week including 4th of January)
  const weekOneOfYear = new Date(`${year}-01-04`);

  // Get weekday of 4th of January
  let firstWeekDayOfWeekOneOfYear = weekOneOfYear.getDay() - 1;
  if (firstWeekDayOfWeekOneOfYear === -1) {
    firstWeekDayOfWeekOneOfYear = 6;
  }

  // Get Monday of first week (subtracting weekday of 4th of January)
  const mondayOfFirstWeekOfYear = new Date(
    Math.floor(
      weekOneOfYear.getTime() -
        firstWeekDayOfWeekOneOfYear * 60 * 60 * 24 * 1000,
    ),
  );

  // Add 7 days * provided week to get Monday
  const mondayOfWeek = new Date(
    mondayOfFirstWeekOfYear.getTime() + 60 * 60 * 24 * 7 * (week - 1) * 1000,
  );

  return mondayOfWeek;
}
